function probeWebGL(attributes: WebGLContextAttributes) {
  // A fresh canvas per attempt: a canvas that already failed one context type cannot grant another.
  const context = document.createElement('canvas').getContext('webgl2', attributes)
    ?? document.createElement('canvas').getContext('webgl', attributes)
    ?? document.createElement('canvas').getContext('experimental-webgl', attributes);
  if (context && 'getExtension' in context) context.getExtension('WEBGL_lose_context')?.loseContext();
  return context;
}

/**
 * True when the browser can create a WebGL context. Prefers a context without a
 * major performance caveat, but accepts a software one so low-end GPUs still get the scene.
 */
export function supportsWebGL(): boolean {
  try {
    return Boolean(probeWebGL({ failIfMajorPerformanceCaveat: true }) ?? probeWebGL({}));
  } catch {
    return false;
  }
}
